var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Lvideo"},[_c('video',{ref:"video",staticClass:"video",attrs:{"autoplay":"","webkit-playsinline":"","playsinline":"","x5-playsinline":"","loop":"","preload":"preload","name":"media","width":_vm.width,"height":_vm.height,"poster":_vm.imgSrc}},[_c('source',{attrs:{"src":_vm.videoSrc,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }